"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import Navbar from "../components/Homapage/Navbar";
import Footer from "../components/Homapage/Footer";
import { useTheme } from "@/app/context/ThemeContext";
import { useLanguage } from "../components/context/LanguageContext";
import Breadcrumb from "../components/Breadcrumb";

interface Document {
  name: string;
  url: string;
}

interface Location {
  LocationName: string;
  Address?: string | null;
  City?: string | null;
  Wilaya?: string | null;
  Email?: string | null;
  Phone?: string | null;
}

interface Tender {
  id: number;
  IDs?: number;
  number?: string;

  title: string;
  slug: string;
  modedepassation: string;
  typeofreview?: string | null;
  DatedeParution?: string | null;
  DateLimitedeSoumission?: string | null;
  Documents?: Document | null;
  LieuDeRetraitDuCahierDesCharges?: Location | null;
  LieudeDepotdesOffres?: Location | null;
  organization: string | null;
  deadline: string | null;
  description: string | null;
  reference: string | null;
  type1: string | null;
  type2: string | null;
  image: string | null;
}

const translations: any = {
  fr: {
 
    label1: "Accueil",
    label2: "Appels d’offres",
        Loading: "Chargement ...",

  },

  en: {
 
    label1: "Home",
    label2: "public tenders",
        Loading: "Loading ...",

  },

  ar: {
  
    label1: "الرئيسية",
    label2: "لمناقصات العمومية",
        Loading: "جارٍ تحميل  ...",

  },
};





export default function PublicTendersPage() {
  const { theme } = useTheme();
  const { language } = useLanguage(); // <-- récupère la langue
  const [tenders, setTenders] = useState<Tender[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const tendersPerPage = 6;
  const [error, setError] = useState<string | null>(null);
  const t = translations[language] || translations.en;

  const STRAPI_URL = process.env.NEXT_PUBLIC_STRAPI_URL;

/* 
  useEffect(() => {
 
           async function fetchTenders(lang: string) {
      setLoading(true);
      setError(null);
      try {
          const res = await fetch(
          `${STRAPI_URL}/api/publictendersses?populate=*&locale=${lang}&sort=id:desc`,
          { cache: "no-store" }
        );
        if (!res.ok) throw new Error(`Failed to fetch: ${res.status}`);

             const data = await res.json();
        setTenders(data.data || []);
      } catch (err) {
        console.error("Impossible de charger les appels d'offres:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchTenders(language);
    
  }, [language]); */


    useEffect(() => {
  let isMounted = true;

  async function fetchTenders() {
    try {
const res = await fetch(`/api/publictenders?locale=${language}`);
        const data = await res.json();

         if (isMounted) setTenders(data.data || []);
      } catch (err) {
        console.error("Impossible de charger les appels d'offres:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
  }

    fetchTenders();
    return () => {
      isMounted = false;
    };
  }, [language]);  
  
  const bgClass = theme === "dark" ? "bg-gray-900 text-gray-100" : "bg-white text-gray-900";
  const heroBg = theme === "dark" ? "bg-gradient-to-r from-blue-900 to-blue-700" : "bg-gradient-to-r from-blue-600 to-blue-800";

  if (loading) {
    return (
      <div className={`min-h-screen ${bgClass}`}>
        <Navbar />
        <div className="flex justify-center items-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
        <Footer />
      </div>
    );
  }

  if (!tenders || tenders.length === 0) {
    return (
       <div className={`min-h-screen transition-colors duration-300 ${bgClass}`}>
      {/*<Navbar />*/}

<div
  className={`relative text-white py-20 mb-16 transition-all duration-300 ${
    theme === "dark" ? "bg-gray-800" : ""
  }`}
  style={{
    backgroundImage: theme === "dark" ? undefined : "url('/test.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="relative z-30 max-w-7xl mx-auto px-4 pt-6 text-white">
       <Breadcrumb
           items={[
            { label: t.label1, href: "/" },
            { label: t.label2 },
          ]}
      />
    </div>

  {/* Overlay sombre */}
  <div className="absolute inset-0 bg-black/50 backdrop-blur-[1px]"></div>

  {/* Contenu */}
  <div className="relative z-10 max-w-4xl mx-auto text-center px-4">
    <h1 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-lg">
      {language === "fr" && "Appels d'Offres"}
      {language === "en" && "Public Tenders"}
      {language === "ar" && "المناقصات العامة"}
    </h1>

    <p className="text-lg opacity-100 max-w-2xl mx-auto drop-shadow-lg">
      {language === "fr" &&
        "Consultez les derniers appels d'offres et marchés publics d'ENAP. Restez informé des opportunités d'affaires."}
      {language === "en" &&
        "Check out the latest public tenders from ENAP. Stay informed of business opportunities."}
      {language === "ar" &&
        "اطلع على أحدث المناقصات العامة من ENAP. ابقَ على اطلاع على فرص الأعمال."}
    </p>
  </div>
</div>
         <div className="text-center py-20">
          <p className="text-gray-500 text-lg">
            {language === "fr" && "Aucun appel d'offre trouvé."}
            {language === "en" && "No public tenders found."}
            {language === "ar" && "لا توجد مناقصات عامة."}
          </p>
        </div>
                <Footer />

      </div>
    );
  }

  // Pagination
  const indexOfLastTender = currentPage * tendersPerPage;
  const indexOfFirstTender = indexOfLastTender - tendersPerPage;
  const currentTenders = tenders.slice(indexOfFirstTender, indexOfLastTender);
  const totalPages = Math.ceil(tenders.length / tendersPerPage);

  const handleNext = () => { if (currentPage < totalPages) setCurrentPage(currentPage + 1); };
  const handlePrev = () => { if (currentPage > 1) setCurrentPage(currentPage - 1); };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${bgClass}`}>
      {/*<Navbar />*/}

<div
  className={`relative text-white py-20 mb-16 transition-all duration-300 ${
    theme === "dark" ? "bg-gray-800" : ""
  }`}
  style={{
    backgroundImage: theme === "dark" ? undefined : "url('/test.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="relative z-30 max-w-7xl mx-auto px-4 pt-6 text-white">
       <Breadcrumb
           items={[
            { label: t.label1, href: "/" },
            { label: t.label2 },
          ]}
      />
    </div>

  {/* Overlay sombre */}
  <div className="absolute inset-0 bg-black/50 backdrop-blur-[1px]"></div>

  {/* Contenu */}
  <div className="relative z-10 max-w-4xl mx-auto text-center px-4">
    <h1 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-lg">
      {language === "fr" && "Appels d'Offres"}
      {language === "en" && "Public Tenders"}
      {language === "ar" && "المناقصات العامة"}
    </h1>

    <p className="text-lg opacity-100 max-w-2xl mx-auto drop-shadow-lg">
      {language === "fr" &&
        "Consultez les derniers appels d'offres et marchés publics d'EMAP. Restez informé des opportunités d'affaires."}
      {language === "en" &&
        "Check out the latest public tenders from ENAP. Stay informed of business opportunities."}
      {language === "ar" &&
        "اطلع على أحدث المناقصات العامة من EMAP. ابقَ على اطلاع على فرص الأعمال."}
    </p>
  </div>
</div>


      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {currentTenders.map((tender) => (
            <TenderCard key={tender.id} tender={tender} theme={theme} language={language} />
          ))}
        </div>
      </div>

      {/* Pagination */}
      <div className="flex justify-center items-center gap-4 mb-16">
        <button
          onClick={handlePrev}
          disabled={currentPage === 1}
          className={`px-4 py-2 rounded-lg border ${
            currentPage === 1 ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700"
          }`}
        >
          {language === "fr" && "Précédent"}
          {language === "en" && "Previous"}
          {language === "ar" && "السابق"}
        </button>

        <span className="text-sm font-medium">
          {language === "fr" && `Page ${currentPage} sur ${totalPages}`}
          {language === "en" && `Page ${currentPage} of ${totalPages}`}
          {language === "ar" && `الصفحة ${currentPage} من ${totalPages}`}
        </span>

        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className={`px-4 py-2 rounded-lg border ${
            currentPage === totalPages ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-blue-600 text-white hover:bg-blue-700"
          }`}
        >
          {language === "fr" && "Suivant"}
          {language === "en" && "Next"}
          {language === "ar" && "التالي"}
        </button>
      </div>

      <Footer />
    </div>
  );
}

// TenderCard avec traduction
function TenderCard({ tender, theme, language }: { tender: Tender; theme: string; language: string }) {
  const cardBg = theme === "dark" ? "bg-gray-800 border-gray-700 hover:border-blue-500" : "bg-white border-gray-200 hover:border-blue-200";
  const textPrimary = theme === "dark" ? "text-gray-100" : "text-gray-900";
  const textSecondary = theme === "dark" ? "text-gray-400" : "text-gray-600";

  const isExpired = tender.DateLimitedeSoumission ? new Date(tender.DateLimitedeSoumission) < new Date() : false;

  return (
    <Link href={`/publictenders/${tender.slug}`} className="block group">
      <div className={`${cardBg} rounded-xl shadow-lg border transition-all duration-300 p-6 h-full`}>
        <div className="flex justify-between items-start mb-4">
          <span className="text-lg font-bold text-blue-600">#{tender.number || tender.number}</span>
          {isExpired && (
            <span className="bg-red-100 text-red-700 text-xs font-semibold px-3 py-1 rounded-full border border-red-300">
              {language === "fr" && "Expiré"}
              {language === "en" && "Expired"}
              {language === "ar" && "منتهي"}
            </span>
          )}
        </div>

        <div className="mb-4">
          <h2 className={`text-xl font-bold ${textPrimary}`}>{tender.modedepassation}</h2>
          <p className="text-sm text-blue-600 font-medium mb-1">{tender.typeofreview || (language === "fr" ? "Avis de publication" : language === "en" ? "Publication notice" : "إشعار النشر")}</p>
          <h3 className={`text-lg font-semibold line-clamp-2 ${textPrimary}`}>{tender.title}</h3>
        </div>

        <div className="space-y-2 mb-4 text-sm">
          <p className={textSecondary}>📅 <span className="font-semibold">{language === "fr" ? "Publication:" : language === "en" ? "Published:" : "تاريخ النشر:"}</span> {tender.DatedeParution}</p>
          <p className={isExpired ? "text-red-500 font-semibold" : textSecondary}>⏳ <span className="font-semibold">{language === "fr" ? "Date limite:" : language === "en" ? "Deadline:" : "الموعد النهائي:"}</span> {tender.DateLimitedeSoumission}</p>
        </div>

        {tender.Documents && (
          <div className="mb-4 p-3 bg-blue-50 dark:bg-blue-900 rounded-lg border border-blue-200 dark:border-blue-700 text-blue-700 dark:text-blue-300 text-sm">
            📄 {language === "fr" ? "Document disponible" : language === "en" ? "Document available" : "المستند متاح"}
          </div>
        )}

        <div className={`space-y-2 mb-4 text-xs ${textSecondary}`}>
          {tender.LieuDeRetraitDuCahierDesCharges && (
            <p>📍 <strong>{language === "fr" ? "Retrait:" : language === "en" ? "Pickup:" : "الاستلام:"}</strong> {tender.LieuDeRetraitDuCahierDesCharges.LocationName}</p>
          )}
          {tender.LieudeDepotdesOffres && (
            <p>📍 <strong>{language === "fr" ? "Dépôt:" : language === "en" ? "Submission:" : "التقديم:"}</strong> {tender.LieudeDepotdesOffres.LocationName}</p>
          )}
        </div>

        <hr className="my-4 border-gray-300 dark:border-gray-700" />

        <div className="flex justify-between items-center">
          <span className={`text-sm font-semibold ${isExpired ? "text-red-600" : "text-green-600"}`}>
            {isExpired ? (language === "fr" ? "Expiré" : language === "en" ? "Expired" : "منتهي") : (language === "fr" ? "Actif" : language === "en" ? "Active" : "نشط")}
          </span>
          <span className="text-blue-600 dark:text-blue-400 group-hover:underline font-semibold text-sm">
            {language === "fr" ? "Voir les détails →" : language === "en" ? "View Details →" : "عرض التفاصيل →"}
          </span>
        </div>
      </div>
    </Link>
  );
}










 